export enum EventPersistentChangeset {
    AdditionOrUpdateSeq = 'AdditionOrUpdateSeq',
    deletion = 'deletion',
    change = 'change',
    modify = 'modify',
    restored = 'restored',
    error = 'error',
    removeInvalid = 'removeInvalid',
    didRecover = 'didRecover',
}

export const DEBUG_TAG = '[SDK][DB]';

// 数据库名
export const DATABASE_NAME = 'TencentDocsSlidePersistent';
export const DATABASE_VERSION = 3;

// 数据库表名
export const TABLE_NAME = 'PersistentStore';
export const MAX_DID_RECOVER_CHECK_COUNT = 3;
export const TIME_INTERVAL_DID_RECOVER_CHECK = 3000;
export const NORMAL_ERROR = 'NORMAL_ERROR';
export const FATAL_ERROR = 'FATAL_ERROR';

/**
 * 延迟释放锁时间间隔
 * 固定间隔时间去检查是否可以释放锁
 */
export const DELAY_RELEASE_LOCK_INTERVAL = 1 * 60 * 1000;
// localstorage 中标记是否有离线数据
export const HAS_OFFLINE_DATA = 'has-offline-data';
